<script>
    import Tourn from './Tourn.svelte';
    import {
        Container,
        Row,
        Navbar,
        Button,
        Tooltip,
        Spinner,
        UncontrolledDropdown,
        DropdownToggle,
        DropdownItem,
        DropdownMenu,
        Nav,
        Dropdown,
    } from 'sveltestrap';
    let tournData = getData();
    let allMonths = [];
    let currMonth = [];
    async function getData() {
        let url =
            'https://api.sheety.co/9af26597890919491cf7667dc438899f/bridgeData/sheet1';
        const response = await fetch(url);
        const data = await response.json();
        allMonths = getMonthsArr(data.sheet1);
        currMonth = allMonths;
        return (tournData = data.sheet1.reverse());
    }
    function getMonthsArr(tournData) {
        const allMonthsData = [];
        tournData.forEach((el) => {
            allMonthsData.push(el.month);
        });
        const months = [...new Set(allMonthsData.reverse())];
        return months;
    }

    function filterByMonth(month) {
        console.log(month);
        if (!month) {
            currMonth = allMonths;
            return;
        }
        currMonth = [month];
    }
</script>

<Container class="mb-6">
    <Navbar color="primary" dark class="mb-3" expand="md">
        <h1 class="white">Brydżowe środy w MindLabie</h1>
        <Nav class="ml-auto" navbar>
            <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>Wybierz miesiąc</DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem on:click={() => filterByMonth()}
                        >Wszystkie</DropdownItem
                    >
                    {#each allMonths as month}
                        <DropdownItem on:click={() => filterByMonth(month)}
                            >{month}</DropdownItem
                        >
                    {/each}
                </DropdownMenu>
            </UncontrolledDropdown>
        </Nav>
    </Navbar>
    {#await tournData}
        <Spinner />
    {:then}
        {#each currMonth as monthRow}
            <Row>
                <h4>{monthRow}</h4>
            </Row>
            <Row>
                {#each tournData.filter((el) => el.month === monthRow) as tourn}
                    <Tourn singleTourn={tourn} />
                {/each}
            </Row>
            <hr />
        {/each}
    {/await}
</Container>

<style>
    .white {
        color: white;
    }
</style>
